import React from 'react';
import {IInventory} from "./models";

interface IInventoryTableProps {
    inventoryData: Array<IInventory>;
}

export function InventoryTable(props: IInventoryTableProps) {
    if (props.inventoryData.length === 0)
        return <div className="text-center">Kirjed puuduvad</div>;
    const orderedByLocationCountsDesc = props.inventoryData
        .sort((b, a) => {
            return ((a.locationQuantities.length < b.locationQuantities.length) ?
                -1 : ((a.locationQuantities.length > b.locationQuantities.length) ? 1 : 0));
        });
    const locationColumns = orderedByLocationCountsDesc[0].locationQuantities.filter(location => location.locationName !== 'Hoiuteenuse osutamise koht');

    // double-check for unique headers that werent included in the first
    for (let i = 1; i < orderedByLocationCountsDesc.length; i++) {
        for (const locationQuantity of orderedByLocationCountsDesc[i].locationQuantities) {
            const existingColumn = locationColumns.find(column => column.remoteObjectId === locationQuantity.remoteObjectId);

            if (existingColumn === null && locationQuantity.locationName === 'Hoiuteenuse osutamise koht')
                continue;

            if (existingColumn === null) {
                locationColumns.push(locationQuantity);
            }
        }
    }

    const locationHeaders = locationColumns.map(location => <th key={location.locationName}>{location.locationName}</th>);

    const tableRows = props.inventoryData.map((item: IInventory) => {
        const rowLocationsColumns = locationColumns.map(
            (column, index) => {
                const rowHasColumn = item.locationQuantities.find(target => target.remoteObjectId === column.remoteObjectId);
                return <td key={index + column.remoteObjectId}>{rowHasColumn ? rowHasColumn.quantity :''}</td>;
            });
       return (
           <tr key={item.remoteId}>
               <td>{item.remoteId}</td>
               <td>{item.name}</td>
               <td>{item.searchCode}</td>
               {rowLocationsColumns}
               <td>{item.expenseQuantity}</td>
           </tr>
       )
    });

    return (
        <div className="table__container scroll-icon">
            <table className='inventory__table table table-responsive table-hover'>
                <thead>
                <tr>
                    <th>Id</th>
                    <th>Nimi</th>
                    <th>Kood</th>
                    {locationHeaders}
                    <th>{props.inventoryData[0].expenseReason}</th>
                </tr>
                </thead>
                <tbody>
                {tableRows}
                </tbody>
            </table>
        </div>
    )
}
